import {Image, Text} from '@primer/react-brand/esm'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import styles from './IdeList.module.css'

interface IdeItemProps {
  href: string
  action: string
  location: string
  image: string
  text: string
  appendix?: string
}

export default function IdeItem({href, action, location, image, text, appendix}: IdeItemProps) {
  return (
    <li className={styles.item} data-ide={action}>
      <a
        href={href}
        className={styles.editorButton}
        {...getAnalyticsEvent({
          action,
          tag: 'icon',
          context: 'editors',
          location,
        })}
      >
        <Image src={`${image}?v=1`} alt="" width="70" height="70" className={styles.editorIcon} />

        <Text as="div" size="100" weight="normal" className={styles.itemText}>
          {text} <span className={styles.itemTextAppendix}>{appendix}</span>
        </Text>
      </a>

      <Text as="div" size="100" weight="normal" className={styles.itemSubtext} aria-hidden="true">
        {text} {appendix}
      </Text>
    </li>
  )
}
